// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Ac88","bigColWidth":"Table_bigColWidth___1W7a","biggerColWidth":"Table_biggerColWidth__JhGo2","row":"Table_row__2SqM1","col":"Table_col__LIyJE"};